import { ROUTES_URL } from './routes';
import { isLeadsmaniaProduct } from './product';

import type { ProductCode } from './product';
import type { StepsType } from 'src/types/User';

export interface IBeginWorkStep {
    order: number;
    id: StepsType;
    link?: string;
    type: 'page' | 'item';
}

export const BEGIN_WORK_STEPS_IDS = {
    EMAIL_CONFIRM: 'email_confirm',
    CHOOSE_PLAN: 'choose_plan',
    CHOOSE_COLLECTIONS: 'choose_collections',
    ADD_CHATS: 'add_chats',
    ADD_KEYWORDS: 'add_keywords',
    COMPLETED: 'completed',
    DESCRIPTION: 'description',
    FORMAT: 'format',
    CHOOSE_STREAM: 'choose_stream',
    CREATE_PROJECT: 'create_project',
} as const;

export const BEGIN_WORK_STEPS: IBeginWorkStep[] = [
    {
        order: 1,
        id: BEGIN_WORK_STEPS_IDS.EMAIL_CONFIRM,
        type: 'item',
    },
    {
        order: 2,
        id: BEGIN_WORK_STEPS_IDS.DESCRIPTION,
        link: ROUTES_URL.BEGIN_WORK_DESCRIPTION,
        type: 'item',
    },
    {
        order: 3,
        id: BEGIN_WORK_STEPS_IDS.CHOOSE_STREAM,
        link: ROUTES_URL.LEADSTREAM,
        type: 'item',
    },
    {
        order: 4,
        id: BEGIN_WORK_STEPS_IDS.FORMAT,
        link: ROUTES_URL.BEGIN_WORK_FORMAT,
        type: 'item',
    },
    {
        order: 5,
        id: BEGIN_WORK_STEPS_IDS.CREATE_PROJECT,
        link: ROUTES_URL.BEGIN_WORK_CREATE_PROJECT,
        type: 'item',
    },
    {
        order: 6,
        id: BEGIN_WORK_STEPS_IDS.ADD_KEYWORDS,
        link: ROUTES_URL.BEGIN_WORK_KEYWORDS,
        type: 'item',
    },
    {
        order: 7,
        id: BEGIN_WORK_STEPS_IDS.CHOOSE_COLLECTIONS,
        link: ROUTES_URL.BEGIN_WORK_COLLECTIONS,
        type: 'item',
    },
    {
        order: 8,
        id: BEGIN_WORK_STEPS_IDS.ADD_CHATS,
        link: ROUTES_URL.BEGIN_WORK_CHATS_AND_CHANNELS,
        type: 'item',
    },
    {
        order: 9,
        id: BEGIN_WORK_STEPS_IDS.CHOOSE_PLAN,
        link: ROUTES_URL.PAYMENT,
        type: 'item',
    },
    {
        order: 10,
        id: BEGIN_WORK_STEPS_IDS.COMPLETED,
        type: 'page',
        // Не используем link - онбординг завершается автоматически после оплаты, переход на /feed
    },
];

export const FILTERED_BEGIN_WORK_STEPS = BEGIN_WORK_STEPS.sort((current, next) => {
    if (current.order < next.order) {
        return -1;
    }

    return 1;
});

export const FILTERED_BEGIN_WORK_STEPS_ITEM_TYPE = FILTERED_BEGIN_WORK_STEPS.filter(({ type }) => type === 'item');

export const FILTERED_BEGIN_WORK_STEPS_PAGE_TYPE = FILTERED_BEGIN_WORK_STEPS.filter(({ type }) => type === 'page');

export const TGHUNTER_ONBOARDING_STEP_IDS: StepsType[] = FILTERED_BEGIN_WORK_STEPS_ITEM_TYPE.map(({ id }) => id);

export const LEADSMANIA_ONBOARDING_STEP_IDS: StepsType[] = [
    BEGIN_WORK_STEPS_IDS.EMAIL_CONFIRM,
    BEGIN_WORK_STEPS_IDS.DESCRIPTION,
    BEGIN_WORK_STEPS_IDS.CHOOSE_STREAM,
];

export const getOnboardingStepIdsByProduct = (productCode?: ProductCode | null): StepsType[] => {
    return isLeadsmaniaProduct(productCode) ? LEADSMANIA_ONBOARDING_STEP_IDS : TGHUNTER_ONBOARDING_STEP_IDS;
};

export const getBeginWorkStepIdByPath = (pathname: string): StepsType | undefined => {
    return FILTERED_BEGIN_WORK_STEPS_ITEM_TYPE.find(({ link }) => link === pathname)?.id;
};
